<template lang="html">
    <section class="aDemo">
        <div v-if="loading" style="text-align: center">
            <span style="display: inline-block;" class="Vlt-spinner Vlt-spinner--large"></span>
        </div>
        <div v-else>
            <div>
                <vlt-field>
                    <vue-phone-number-input :translations="lang ? lang.phonetranslation : null" color="#131415"
                        :no-validator-state="false" :default-country-code="nexmo.region" v-model="prettyNumber"
                        @update="onUpdate" />
                </vlt-field>
                <div class="Vlt-native-dropdown">
                    <select name="iSelect" id="iSelect" v-model="iType" @change="typeChange">
                        <option value="fraud">{{ t('Fraud Score/SIM Swap') }}</option>
                        <option value="fd">{{ t('Fraud Defender Check') }}</option>
                        <option value="basic">{{ t('Basic Insight') }}</option>
                        <option value="standard">{{ t('Standard Insight') }}</option>
                        <option value="advanced">{{ t('Advanced Insight') }}</option>
                    </select>
                </div>
                <div v-if="iType == 'fd'" class="Vlt-native-dropdown">
                    <select v-model="product">
                        <option value="voice">{{ t('Voice') }}</option>
                        <option value="sms">{{ t('SMS') }}</option>
                    </select>
                </div>
                <vlt-button :label="t('Get Number Info')" quaternary app @click="doIt" :disabled="(!isValid)" />
                <div v-if="spin" style="margin-top:-40px" class="Vlt-spinner Vlt-spinner--small inline"></div>
                <div v-if="cname" style="display: inline-block;margin-left: 2em;">
                    <vlt-icon icon="thumbs-up" color="green" />
                    {{ t('CNAM Information Available in the US') }}
                </div>
            </div>
            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-1of4">
                    <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                        <h3>{{ t(ftitle) }}</h3>
                        <json-view style="z-index:100" v-if="Object.keys(fraud).length > 0" :data="fraud" :maxDepth="3"
                            :rootKey="fraud.national_format_number" />
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                        <h3>{{ t('Basic') }}</h3>
                        <json-view style="z-index:100" v-if="Object.keys(basic).length > 0" :data="basic" :maxDepth="3"
                            :rootKey="basic.national_format_number" />
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                        <h3>{{ t('Standard') }}</h3>
                        <json-view style="z-index:100" v-if="Object.keys(standard).length > 0" :data="standard"
                            :maxDepth="3" :rootKey="standard.national_format_number" />
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">
                    <div style="font-size:12px" class="Vlt-card Vlt-card--scrollable ">
                        <h3>{{ t('Advanced') }}</h3>
                        <json-view style="z-index:100" v-if="Object.keys(advanced).length > 0" :data="advanced"
                            :maxDepth="3" :rootKey="advanced.national_format_number" />
                    </div>
                </div>
            </div>
            <br><br>
            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-1of3">
                    <reportsAPI :nexmo="nexmo" reportType="NUMBER-INSIGHT" :lang="lang" :baseLang="baseLang" />
                </div>
            </div>
            <vlt-modal class="Vlt-modal--large" :message="t('Loading Insight') + '...'"
                :title="t('Number Insight') + ': ' + t(iType)" :canCancel="false" :visible="showInsight"
                @close="showInsight = false" @confirm="showInsight = false">
                <json-view :data="insights" :maxDepth="3" :rootKey="insights.national_format_number" />
            </vlt-modal>
        </div>
    </section>
</template>

<script lang="js">
import axios from 'axios';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import {
    $NODEBASE
} from '../base';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import {
    JSONView
} from "vue-json-component";
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltModal,
} from "@vonagevolta/vue";
import reportsAPI from "@/components/reportsAPI";
export default {
    name: 'sampleDemo',
    data() {
        return {
            number: '',
            prettyNumber: '',
            numberStuff: {},
            fromNumber: '',
            isValid: true,
            DEMO: {},
            insights: [],
            showInsight: false,
            iType: 'fraud',
            warned: false,
            basic: [],
            standard: [],
            advanced: [],
            fraud: [],
            cname: false,
            spin: false,
            keepalive: null,
            ftitle: 'Fraud Score/SIM Swap',
            product: 'sms',
            loading: true,
            debugURL: '',//'https://neru-ef3346a6-debug-debug.use1.runtime.vonage.cloud',
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        baseLang: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        },
        lang: {
            type: Object,
            required: false
        }
    },
    watch: {
        lang: function (newVal) {
            // Any strings that need to be dynamically changed on Language Change go here...
        }
    },
    methods: {
        typeChange() {
            if (!this.warned && this.iType != "fd" && this.iType != "fraud") {
                this.warned = true;
                this.$swal({
                    title: '<h4 style="color:red" >' + this.t('Warning') + '</h4>',
                    showCloseButton: true,
                    html: '<h5>' + this.t('Standard and Advanced Insights are not available for all countries.  Please see the following page for more information regarding Insight Availability:') + '</h5><br><h4><a style="color:green;text-decoration: underline" target="_blank" href="https://nexmoinc.atlassian.net/wiki/spaces/VER/pages/793477207/Number+Insight+Country+Support">' + this.t('Number Insight Country Support') + '</a>  </h4>',
                    icon: 'info'
                });
            };
            if (this.iType == "fd") this.ftitle = 'Fraud Defender';
            if (this.iType == "fraud") this.ftitle = 'Fraud Score/SIM Swap';
        },
        doIt() {
            this.spin = true;
            if (this.iType == 'fraud') {
                this.$swal({
                    title: '<h4 style="color:blue" >' + this.t('Fraud Score and SIM Swap') + '</h4>',
                    showCloseButton: true,
                    html: '<h5>' + this.t('Fraud Score and SIM Swap can be called independently.<br><br>They are part of Numbers Insight V2, which is currently in Beta</h5>'),
                    icon: 'info'
                });
            }
            this.DEMO.post('insight', {
                phone: this.number,
                type: this.iType,
                cname: this.cname,
                product: this.product,
            }).then(request => {
                console.log("Demo result for  " + this.number);
                console.log(request.data);
                this.insights = request.data;
                this.showInsight = false;
                if (this.iType == 'fd') {
                    this.fraud = request.data;
                }
                if (this.iType == 'fraud') {
                    this.fraud = request.data;
                }
                if (this.iType == 'basic') {
                    this.basic = request.data;
                }
                if (this.iType == 'standard') {
                    this.standard = request.data;
                }
                if (this.iType == 'advanced') {
                    this.advanced = request.data;
                }
                this.spin = false;
            });
        },
        async register() {
            console.log("Registering the Demo Component with the associated backend");
            await this.DEMO.post('register', {});
            this.loading = false;
            if (this.demoItem.port) {
                this.keepalive = setInterval(() => {
                    this.DEMO.get('keepalive?id=' + this.nexmo.userid);
                    console.log("Keptalive!")
                }, 60 * 1000);
            }
        },
        onUpdate(payload) {
            console.log("Number payload: ", payload);
            this.numberStuff = payload;
            if (payload.isValid) {
                this.isValid = payload.isValid;
                this.cname = payload.countryCode == "US" ? true : false;
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.cname = test.country == "US" ? true : false;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else this.isValid = false;
            }
        },
        t(key) { // T for Translate...
            return this.$tr(key, this.lang, this.baseLang)
        },
    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-modal": VltModal,
        "json-view": JSONView,
        reportsAPI,
    },
    created() {
        // If the backend is a NODE server, use this...
        var postscript = "/insight";
        if ($NODEBASE.indexOf('ngrok') > 0) {
            postscript = '';
        };
        var url = $NODEBASE + postscript;
        if (this.debugURL && process.env.NODE_ENV === 'development') this.demoItem.port = this.debugURL;
        if (this.demoItem.port) { //VCR
            console.log("Wow, using the VCR instance!!!", this.demoItem.port)
            url = this.demoItem.port;
        }
        this.DEMO = axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        // If the backend is a PHP server, use this...
        // this.DEMO = $HTTPDEMO
        // 
        this.register();
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.onUpdate({
            isValid: true,
            formatInternational: this.nexmo['phone'],
            formattedNumber: this.nexmo['phone'],
            countryCode: this.nexmo['region'],
        });
        console.log(this.nexmo);
    },
    beforeDestroy() {
        if (this.keepalive) {
            clearInterval(this.keepalive);
            this.keepalive = null;
        }
    },

}
</script>

<style scoped lang="scss"></style>
